import { render, staticRenderFns } from "./BeneficiarioControlador.vue?vue&type=template&id=a598f848&scoped=true"
import script from "./BeneficiarioControlador.vue?vue&type=script&lang=js"
export * from "./BeneficiarioControlador.vue?vue&type=script&lang=js"
import style0 from "./BeneficiarioControlador.vue?vue&type=style&index=0&id=a598f848&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a598f848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a598f848')) {
      api.createRecord('a598f848', component.options)
    } else {
      api.reload('a598f848', component.options)
    }
    module.hot.accept("./BeneficiarioControlador.vue?vue&type=template&id=a598f848&scoped=true", function () {
      api.rerender('a598f848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/BeneficiarioControlador.vue"
export default component.exports